import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import dayjs from 'lib/dayjs';
import { toNumber } from 'lodash-es';
import { UIMessages } from '../../useChatView';
import { memo } from 'react';
import { useTranslate } from '@tolgee/react';

interface SysInitConversationMsgProps extends BaseSysMsgProps {
  msg: UIMessages;
}

export const SysInitConversationMsg = memo((props: SysInitConversationMsgProps) => {
  const { raw } = props;
  const { sendTime, fromUserName } = raw;
  const { t } = useTranslate();

  return (
    <SystemMessage>
      {dayjs(toNumber(sendTime)).format('MM-DD HH:mm:ss')}
      &nbsp;
      {t('messageType.SYS_INIT_CONVERSATION', {
        who: fromUserName || '',
      })}
    </SystemMessage>
  );
});
